import { Socket, io } from "socket.io-client";

import {
  ClientToServerEvents,
  ServerToClientEvents,
} from "@classview/shared-types";

const socketClient: Socket<ServerToClientEvents, ClientToServerEvents> = io(
  import.meta.env.VITE_API_URL,
  {
    reconnectionDelay: 1000, // defaults to 1000
    reconnectionDelayMax: 1000, // defaults to 5000
    autoConnect: false,
  },
);

export default socketClient;
